import React, { useEffect, useState } from 'react';
import Navigation from '../components/Navigation';
import { NavLink } from 'react-router-dom';
import base_url from '../config/Config';
import axios from 'axios';
import Sidebar from '../components/Sidebar';
import Spinner from 'react-bootstrap/Spinner'; // Import Spinner component
import { } from 'react-icons/fa';
import PageLoader from '../components/PageLoader';

const BankVerification = () => {
   

    // BankVerification state
    // const [bankVerification, setBankVerification] = useState([]);
    const [pageLoading, setPageLoading] = useState(true);
    const [isDownloading, setIsDownloading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [bankCheck, setBankCheck] = useState([]);
    const [bankFaild, setBankFaild] = useState([]);
    const [showBankFaild, setShowBankFaild] = useState(false);
    const [showBankCheck, setShowBankCheck] = useState(true);
    const [searchOption, setSearchOption] = useState('');
    const [searchInput, setSearchInput] = useState('');
  

    // excel export
     const handleExportBankVerification = async () => {
        setIsDownloading(true);
        try {
            const response = await axios.get(`${base_url}/api1/creditCheck/creditCheckToExport`, {
                responseType: 'blob'
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Pending_BankVerification_data.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            alert('Export Pending BankVerification Data successfully');
        } catch (error) {
            console.error('Error generating export:', error.response?.data || error.message);
            alert('Export Pending BankVerification Data failed');
        } finally {
            setIsDownloading(false);
        }
    };
    const fetchBankVerification = async (status) => {
        try {
            const response = await axios.get(`${base_url}/api1/customer/customerStatus?status=${status}`);
            const data = response.data.map(item => ({ ...item, actionPerformed: false }));
            return data.reverse();
        } catch (error) {
            console.error(`Error fetching ${status} data:`, error);
            return [];
        }
    };

    useEffect(() => {
        const loadData = async () => {
            if (showBankCheck) {
                const data = await fetchBankVerification('account verified');
                setBankCheck(data);
            } else if (showBankFaild) {
                const data = await fetchBankVerification('account failed');
                setBankFaild(data);
            }
        };

        loadData().finally(() => setPageLoading(false));
    }, [showBankCheck, showBankFaild]);

    const handleShowBankCheck = () => {
        setShowBankCheck(true);
        setShowBankFaild(false);
    };

    const handleShowBankFaild = () => {
        setShowBankFaild(true);
        setShowBankCheck(false);
    };

  
    const handleReadyToDisburse = async (id) => {
        setIsLoading(true); 
        try {
            const response = await axios.post(`${base_url}/api1/account/verifiedCustomer?id=${id}`);
            if (response.status === 200) {
                alert(`Reday To Disbursed for ID ${id} was successful.`);
            }
        } catch (error) {
            console.error('Error performing KYC check:', error.response?.data || error.message);
            alert(`Ready to Disbursed check failed. ${id}`);
        }
        finally {
            setIsLoading(false); 
        }
    };
    
       
// search filter API 
const handleSearch = (event) => {
    event.preventDefault();
    if (searchOption && searchInput) {
        let url = '';
        switch (searchOption) {
            case 'borrower_name':
                url = `${base_url}/api1/customer/searchByBorrowerName?borrowerName=${searchInput}`;
                break;
            case 'borrower_id':
                url = `${base_url}/api1/customer/searchByBorrowerId?borrowerId=${searchInput}`;
                break;
            case 'phone':
                url = `${base_url}/api1/customer/searchByMobileNumber?mobileNumber=${searchInput}`;
                break;
            default:
                break;
        }
        axios.get(url).then(
            (response) => {
                console.log(response.data);
                setBankCheck(response.data);
            },
            (error) => {
                console.log(error);
            }
        );
    }
};

// search filter API end 

    if (pageLoading) return <PageLoader text="Loading..." />;

    return (
        <>
            <div className='overviewsaa'>
                <h4>CreditCheck Details</h4>
            </div>
            <div className='navigationss mb-5'>
                <Navigation />
            </div>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-lg-2 col-md-2 sidebarnavigartion'>
                        <div className='lmssidebar'>
                            <Sidebar />
                        </div>
                    </div>
                    <div className='col-lg-10 col-md-10'>
                        <div className='dashboardlms mt-5 text-center'>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='searchtoll'>
                                        <form name="searchForm" action="">
                                            <div className='row'>
                                            <div className="col-md-2 col-3">
                                                    <div className=" required">
                                                        <select name="option" id="option" className="form-control" value={searchOption} onChange={(e) => setSearchOption(e.target.value)} required="required">
                                                            <option value="" selected="selected">Search By</option>
                                                            <option value="borrower_name">Borrower Name</option>
                                                            <option value="borrower_id">Partner Id</option>
                                                            <option value="phone">Phone</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 col-6">
                                                    <div className=" required">
                                                        <input type="text" className="form-control" placeholder="Search..." value={searchInput} onChange={(e) => setSearchInput(e.target.value)} required/>
                                                    </div>
                                                </div>
                                                <div className="col-md-1 col-3">
                                                    <div className=" required iconsss">
                                                        <button type="submit" onClick={handleSearch} className="btn btn-sm btn-primary">Search</button>
                                                    </div>
                                                </div>
                                                <div className='col-md-2 col-5 mt-2'>
                                                    <div className='rejectlist'>
                                                        <NavLink onClick={handleShowBankCheck} to="#">Bank Checked</NavLink>
                                                    </div>
                                                </div>
                                                <div className='col-md-2 col-4 mt-2'>
                                                    <div className='rejectlist'>
                                                        <NavLink to="#" onClick={handleShowBankFaild} >Bank_Reject</NavLink>
                                                    </div>
                                                </div>
                                                <div className="col-md-1 col-3 mt-2">
                                                <div className="export">
                                                        <NavLink to="#" className="exportbutton" onClick={handleExportBankVerification}>
                                                            {isDownloading ? (
                                                                <Spinner animation="border" size="sm" />
                                                            ) : (
                                                                <>
                                                                Export
                                                                </>
                                                            )}
                                                        </NavLink>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <div className='col-md-12 col-lg-12'>
                                    <div className='kyc table-responsive allcustomer mt-3 mb-5'>
                                        {showBankFaild && bankFaild.length > 0 && (
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <th>Customer_id</th>
                                                        <th>Emp_Id</th>
                                                        <th>Name</th>
                                                        <th>Date_of_Birth</th>
                                                        <th>Mobile</th>
                                                        <th>Pan_Number</th>
                                                        <th>Account_Number</th>
                                                        <th>IFSC_Code</th>
                                                        <th>Bank_Name</th>
                                                        <th>Action</th>
                                                    </tr>
                                                    {bankFaild.map((data, index) => (
                                                        <tr key={index}>
                                                            <td>{data.id}</td>
                                                            <td>{data.empId}</td>
                                                            <td>{data.borrowerName}</td>
                                                            <td>{data.dob}</td>
                                                            <td>{data.mobileNumber}</td>
                                                            <td>{data.panNumber}</td>
                                                            <td>{data.accountNumber}</td>
                                                            <td>{data.ifscCode}</td>
                                                            <td>{data.bankName}</td>
                                                            <td>{data.status}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        )}
                                        {showBankFaild && bankFaild.length === 0 && (
                                            "No Rejected CreditCheck today."
                                        )}
                                        {showBankCheck && bankCheck.length > 0 && (
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <th>Customer_Id</th>
                                                        <th>Emp_Id</th>
                                                        <th>Borrower_Name</th>
                                                        <th>Date_of_Birth</th>
                                                        <th>Phone_Number</th>
                                                        <th>Pan_Number</th>
                                                        <th>Account_Number</th>
                                                        <th>IFSC_Code</th>
                                                        <th>Bank_Name</th>
                                                        <th>Action</th>
                                                    </tr>
                                                    {bankCheck.map((data, index) => (
                                                        <tr key={index}>
                                                            <td>{data.id}</td>
                                                            <td>{data.empId}</td>
                                                            <td>{data.borrowerName}</td>
                                                            <td>{data.dob}</td>
                                                            <td>{data.mobileNumber}</td>
                                                            <td>{data.panNumber}</td>
                                                            <td>{data.accountNumber}</td>
                                                            <td>{data.ifscCode}</td>
                                                            <td>{data.bankName}</td>
                                                            <td className='creditcheck'> <button onClick={() => handleReadyToDisburse(data.id)} disabled={isLoading} >
                                                             {isLoading ? "Processing..." : "Ready_to_Disbursed"}
                                                            </button></td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        )}
                                        {showBankCheck && bankCheck.length === 0 && (
                                            "No handleReady To Disburse."
                                        )}
                                    </div>
                                </div>
                                <hr />
                                {/* <div className='col-md-12 col-lg-12'>
                                    <div className='buttonss mt-3 mb-3 text-center'>
                                        <button type='submit'>Submit</button>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </>
    );
};

export default BankVerification;
